module.exports = __webpack_public_path__ + "static/media/course-tile.37a1e5bb.png";